module.exports = __webpack_public_path__ + "img/lucky(5).c36b500a.png";